/**
 * SVG icons injector
 * ==================
 *
 * This script utilizes ssClientUtils to look for "ss-svg-icons" meta tags in
 * the format:
 *
 *     <meta name="ss-svg-icons" content="http://...path/to/icons.svg">
 *
 * For each tag, it fetches the URL given by the `content` attribute using XHR,
 * and embeds it into the page, and hides it (using `display: none`).
 *
 * Inspired by the icon loading script within go/pemberly-davinci.
 *
 * Usage
 * -----
 *
 * In Rails, it is recommended to use the Assets Pipeline to leverage caching
 * capabilities.
 *
 * In layout:
 *
 *     <head>
 *       ...
 *       <%= yield :meta %>
 *       ...
 *
 * In view, use `content_for :meta`, `content_tag` and `image_path` heleprs:
 *
 *     <%
 *       content_for :meta do
 *         content_tag :meta, :name => 'ss-svg-icons', :content => image_path('artdeco/icons.svg')
 *       end
 *     %>
 * 
 */
import ssClientUtils from '@linkedin/slideshare-client-utils';

(function() {
  ssClientUtils.dom.onContentLoaded.then(ssClientUtils.svg.loadSvgs);
}());
